import { TblViewSpec } from '../../../../core/table/table-view.types';
import { cpOrderInvoicesListAllColumnsView } from './CpOrderInvoicesListTableSpec';

const allColumns = cpOrderInvoicesListAllColumnsView();

// This is the actual runtime default view for CP Order Invoices, minimal and user-friendly.
export function getCpOrderInvoicesInitialView(): TblViewSpec {
    return {
        key: '1',
        title: 'Default',
        sections: [
            {
                title: 'Order Info',
                cols: ['OrderNum', 'Type'],
            },
            {
                title: 'Pharmacy',
                cols: ['Pharmacy'],
            },
            {
                title: 'Vendor Info',
                cols: ['VendorName', 'VendorInvoiceNum', 'TotalAmount'],
            },
            {
                title: 'Process Dates',
                cols: ['DateCreated', 'VendorInvoiceDate', 'InvoiceReconciledDate'],
            },
        ],
        sortby: allColumns.sortby,
    };
}
